<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import store from '../../store'
import Alert from '../Alert/Alert.vue';
import Loading from '../Loading/Loading.vue';
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import AccountForm from '../AccountForm/AccountForm.vue'
import AccountAvatar from '../AccountAvatar/AccountAvatar.vue'
import AccountActivity from '../AccountActivity/AccountActivity.vue';
import AccountPassword from '../AccountPassword/AccountPassword.vue';
import AccountNotifications from '../AccountNotifications/AccountNotifications.vue';

export default Vue.extend({
    components: {
        Alert,
        Loading,
        InfoWidget,
        AccountForm,
        AccountAvatar,
        AccountActivity,
        AccountPassword,
        AccountNotifications
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            tips: state => state.account.tips,
            userLoading: state => state.account.user.loading,
            passwordLoading: state => state.account.password.loading,
            notificationLoading: state => state.account.notifications.loading,
            supplier: state => state.auth.supplier
        })
    },
    watch: {
        supplier: (supplier) => {
            store.dispatch('account/getAccount');
            store.dispatch('account/getAccountActivity', supplier.id);
            store.dispatch('account/getAccountNotifications');
            store.dispatch('nav/toggleNavMenu', false);
        }
    },
    created () {
        const supplierId = this.supplier.id;
        this.getAccount();
        this.getLanguages();
        this.toggleNavMenu(false);
        this.getAccountActivity(supplierId);
        this.getAccountNotifications();
    },
    methods: {
        ...mapActions({
            getAccount: 'account/getAccount',
            getLanguages: 'admin/getLanguages',
            toggleNavMenu: 'nav/toggleNavMenu',
            getAccountActivity: 'account/getAccountActivity',
            getAccountNotifications: 'account/getAccountNotifications'
        })
    },
});
</script>

<template>
    <div class="account-page">
        <account-avatar/>
        <account-form/>
        <account-password/>
        <account-notifications v-if="user.admin"/>
        <account-activity/>
        <info-widget ref="infoWidget" :tips="tips"/>
        <loading v-if="userLoading || passwordLoading || notificationLoading"/>
        <alert :translation-prefix="'admin.alert'"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AccountPage/AccountPage.vue